
  function parseIncomingMsgAndEncryptIE(message, fnRef) {
      var msgJson = JSON.parse(message);
      //var self = this;
      // if (msgJson.MSG_TYPE === "LOGIN_CLICKED") {
        var publicKeyHandle;
        var encryptAlgorithm = { name: "RSA-OAEP", hash: { name: "SHA-256" } };
        var randomSize = new Uint8Array(4);
        randomSize[0] = 0;
        randomSize[1] = 0;
        randomSize[2] = 0;
        randomSize[3] = 32;
        var publicKeyObj = {
                          kty: "RSA",
                          ext: true,
                          n: msgJson.modulus,
                          e: msgJson.exponent
                        };

  var publicKey = JSON.stringify(publicKeyObj);
  
   var publicKeyBytes = toSupportedArray(publicKey);

    var cryptoObj = window.msrCrypto;
  
  var encryptedDataPromise = cryptoObj.subtle.importKey("jwk",publicKeyBytes, encryptAlgorithm);      
  var windowSelf = window;
  encryptedDataPromise.onerror = function(e) {fnRef("ERROR")};
  var rsaBlock;
  var encryptedBytes;
  encryptedDataPromise.oncomplete = function(e) {
            // Results are returned with the event 'e' on the target property.
            // This key handle is used to represent the key in crypto operations
            // it does not contain any key data.  If you want see the key data call KeyExport
            publicKeyHandle = e.target.result;

            console.log(publicKeyHandle);

            //var encryptPromise = encrypt('vikas', 'EZlN2NMB2wP2cUd5fXI3DbqVreP3liInj5gh2M1u7Oc=', 'y-1HTH7T_2LUazMyZdX4BR6GFtp0GSoOQuASxAyhHb4KIPYtdY1KWvYLSAnIOMfLf1OKYB7PuKwIGSLCqIEg628dJELLqvwh_kn0WIbq2XqFNhc1Z11L9HGBuA76qy6voosRyFuG3fnfHnEaaaS6jKgs33kzBUr_GA8RDctmqnRTw5_HfpGLsdxVYFGE9xhAgc1JzP2GEdIWQz5kE-iz3D2MS0uZzosfqgW8YXdF53zekS33nDyUKWygVsx8kUFN0VrC9FrrJX5in4BFnNxfFziKN8n4EpwxQwYkOUhcUpGR0Srg7pVtRLVZnYAsBS5WnSzaQuIEV5xxNbBEIz6znQ', 'AQAB');
            //console.log("Encrypt promise inside importKey is " + encryptPromise);
            //return encryptPromise;
            let encryptPromise = encryptIE(msgJson.password, msgJson.token, publicKeyHandle, encryptAlgorithm);

            encryptPromise.oncomplete = function(e) {
                encryptedBytes = toSupportedArray(e.target.result);
            var len = encryptedBytes.length;
            var holder;
            var bytes = new Uint8Array(len);
            var bytesCopy = new Uint8Array(len);
            for (var i = 0; i < len; i += 1) {
            bytesCopy[i] = encryptedBytes[i];
            bytes[i] = encryptedBytes[i];
            }
            rsaBlock = btoa(String.fromCharCode.apply(null, bytesCopy));
            console.log('encoded rsaBlock inside encrypt() function is ' + rsaBlock);
            fnRef(rsaBlock);
            }

            encryptPromise.onerror = function(e) {fnRef("ERROR")};
  }
}
  function encryptIE(password, randomToken, publicKeyHandle, encryptAlgorithm) {

            var randomSize = new Uint8Array(4);
        randomSize[0] = 0;
        randomSize[1] = 0;
        randomSize[2] = 0;
        randomSize[3] = 32;

  var cryptoObj = window.msrCrypto;
  var subtle = cryptoObj.subtle;
  var tokenArray = base64ToArrayBuffer(randomToken);
  var pwLen = new Uint8Array(4);
  pwLen[0] = 0;
  pwLen[1] = 0;
  pwLen[2] = 0;
  pwLen[3] = password.length;
  var pw = strToUint8arr(password);
  var finalBuffer = new Uint8Array(randomSize.length + tokenArray.length + pwLen.length + pw.length);
  finalBuffer.set(randomSize);
  finalBuffer.set(tokenArray, randomSize.length);
  finalBuffer.set(pwLen, randomSize.length + tokenArray.length);
  var totalSize = randomSize.length + tokenArray.length + pw.length;
  finalBuffer.set(pw, randomSize.length + tokenArray.length + pwLen.length);
  
  if (!publicKeyHandle) {
    console.log("Invalid Key");
    return;
  }
  var plainTextBytes = toSupportedArray(finalBuffer);
  var rsaBlock;
  // Now that we have a public key, we can encrypt our data
  console.log("going to encrypt inside encrypt() function..");
  var encryptPromise = subtle.encrypt(encryptAlgorithm, publicKeyHandle, plainTextBytes);
  return encryptPromise;

  }

  // Converts Arrays, ArrayBuffers, TypedArrays, and Strings to
// to either a Uint8Array or a regular Array depending on browser support.
// You should use this when passing byte data in or out of crypto functions
         function toSupportedArray(data) { 
  
             // does this browser support Typed Arrays? 
             var typedArraySupport = (typeof Uint8Array !== "undefined"); 
  
             // get the data type of the parameter 
             var dataType = Object.prototype.toString.call(data); 
             dataType = dataType.substring(8, dataType.length - 1); 
  
             // determine the type 
             switch (dataType) { 
  
                 // Regular JavaScript Array. Convert to Uint8Array if supported 
                 // else do nothing and return the array 
                 case "Array": 
                     return typedArraySupport ? new Uint8Array(data) : data; 
  
                     // ArrayBuffer. IE11 Web Crypto API returns ArrayBuffers that you have to convert 
                     // to Typed Arrays. Convert to a Uint8Arrays and return; 
                 case "ArrayBuffer": 
                     return new Uint8Array(data); 
  
                     // Already Uint8Array. Obviously there is support. 
                 case "Uint8Array": 
                     return data; 
  
                 case "Uint16Array": 
                 case "Uint32Array": 
                     return new Uint8Array(data); 
  
                     // String. Convert the string to a byte array using Typed Arrays if 
                     // supported. 
                 case "String": 
                    var newArray = typedArraySupport ? new Uint8Array(data.length) : new Array(data.length);
                     for (var i = 0; i < data.length; i += 1) { 
                        newArray[i] = data.charCodeAt(i); 
                    } 
                    return newArray; 
                   // Some other type. Just return the data unchanged. 
                default: 
                   throw new Error("toSupportedArray : unsupported data type " + dataType);             } 
 
       }

      function getArray(myString) {
          var len = myString.length;
          var arr =[];
          for (var i = 0; i < len; i++) {
            arr[i] = myString.charCodeAt(i);
          }
          return arr;
      }

      function base64ToArrayBuffer(base64Data) {
        var binary_string =  window.atob(base64Data);
        var len = binary_string.length;
        var bytes = new Uint8Array( len );
        for (var i = 0; i < len; i++) {
          bytes[i] = binary_string.charCodeAt(i);
        }
        return bytes;
      }

      function strToUint8arr(string) {
          let charList = string.split(''),
          uintArray = [];
          for (var i = 0; i < charList.length; i++) {
              uintArray.push(charList[i].charCodeAt(0));
          }
          return new Uint8Array(uintArray);
      }

                 // General function to handle errors
        function handleError(text) {
            return function (e) {
              console.log(text + " : " + e.type);
            };
        }
        // Converts an Array or TypedArray to a hex string
        function bytesToHexString(bytes) {
            var result = "";
            for (var i = 0 ; i < bytes.length; i++) {
                if (i % 4 === 0 && i !== 0) result += "-";
                var hexval = bytes[i].toString(16).toUpperCase();
                result += hexval.length === 2 ? hexval : "0" + hexval;
            }
            return result;
        }
export default parseIncomingMsgAndEncryptIE;
